import React from 'react';
import { PageLayout } from '@/shared/layout';
import { UtilityKpiDashboard } from './components/UtilityKpiDashboard';
import { UtilityModulesGrid } from './components/UtilityModulesGrid';
import { UtilityRecentActivity } from './components/UtilityRecentActivity';
import { UtilityAIAssistant } from './components/UtilityAIAssistant';

export function UtilityPage() {
  return (
    <PageLayout
      title="Tiện ích & Năng lượng"
      description="Quản lý tập trung hệ thống điện, nước, tự động hóa và phân tích tiêu thụ năng lượng."
    >
      <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">

        {/* Top KPIs Dashboard */}
        <UtilityKpiDashboard />

        {/* Navigation Hub */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-8 flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-black text-slate-900 flex items-center gap-2">
                <div className="w-2 h-6 bg-blue-500 rounded-full" />
                Vận hành Tiện ích (Utility Operations)
              </h3>
            </div>
            <div className="flex-1">
              <UtilityModulesGrid />
            </div>
          </div>

          <div className="lg:col-span-4 flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-black text-slate-900 flex items-center gap-2">
                <div className="w-2 h-6 bg-cyan-500 rounded-full" />
                Lịch sử hệ thống
              </h3>
              <button className="text-xs font-medium text-blue-600 hover:text-blue-700 hover:underline transition-colors cursor-pointer">
                Xem toàn bộ &rarr;
              </button>
            </div>
            <div className="flex-[2] flex flex-col min-h-0">
              <UtilityRecentActivity />
            </div>

          </div>
        </div>
      </div>
    </PageLayout>
  );
}

export default UtilityPage;
